import { render, staticRenderFns } from "./stand-input.vue?vue&type=template&id=b526a01e&scoped=true"
import script from "./stand-input.vue?vue&type=script&lang=js"
export * from "./stand-input.vue?vue&type=script&lang=js"
import style0 from "./stand-input.vue?vue&type=style&index=0&id=b526a01e&prod&lang=less&scoped=true"
import style1 from "./stand-input.vue?vue&type=style&index=1&id=b526a01e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b526a01e",
  null
  
)

export default component.exports